import React from "react";

/**
 * Единый переключатель-«пилюли»: фильтры и табы внутри страницы.
 * Заменяет локальные наборы .pd-tag, .pd-tags, .plan-view-switch__btn,
 * .chat-tabs__btn, .anketa-lang-btn.
 *
 * <SegmentedControl
 *   value={activeTab}
 *   onChange={setActiveTab}
 *   items={[{ value: "all", label: "Все" }, { value: "uzi", label: "УЗИ" }]}
 * />
 *
 * tone="primary"  — активный тёмно-синий (по умолчанию, как было в списках)
 * tone="accent"   — активный жёлтый (как табы в шапке карточки пациента)
 * size="sm" | "md"
 */
const SegmentedControl = ({
    value,
    onChange,
    items = [],
    tone = "primary",
    size = "sm",
    ariaLabel,
    className,
}) => {
    const classes = [
        "ui-segment",
        `ui-segment--${tone}`,
        `ui-segment--${size}`,
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div
            aria-label={ariaLabel}
            className={classes}
            role="tablist">
            {items.map((item) => {
                const itemValue = item.value ?? item.key;
                const isActive = itemValue === value;
                return (
                    <button
                        key={itemValue}
                        aria-selected={isActive}
                        className={`ui-segment__btn${
                            isActive ? " is-active" : ""
                        }`}
                        role="tab"
                        type="button"
                        onClick={() => onChange?.(itemValue)}>
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedControl;
